/* eslint-disable no-underscore-dangle */
export class Duration {
  /* 24 hours as minutes */
  static MAX_DAILY_MINUTES = 1440;

  private _hours: number;
  private _minutes: number;

  constructor(minutes?: number) {
    if (typeof minutes === 'number') {
      const [hrs, mins] = Duration.convertMinsToDuration(minutes);
      this._hours = hrs;
      this._minutes = mins;
    }
  }

  get hours(): number {
    return this._hours;
  }

  set hours(hours: number) {
    this._hours = hours;
  }

  get minutes(): number {
    return this._minutes;
  }

  set minutes(minutes: number) {
    this._minutes = minutes;
  }

  get totalMinutes(): number {
    return this._hours * 60 + this._minutes;
  }

  /**
   * converts the duration to a string in the format hh:mm
   * @returns string representation of the duration in the format hh:mm
   */
  public toString(): string {
    const hrs = Duration.formatDurationSegment(this._hours);
    const mins = Duration.formatDurationSegment(this._minutes);
    return `${hrs}:${mins}`;
  }

  /**
   * converts the duration string to total minutes
   * @param duration string representation of the duration in the format hh:mm
   * @returns total minutes
   */
  public static convertDurationStringToMins = (duration: string) => {
    const [hrs, mins] = duration.split(':');

    if (!hrs || !mins || hrs.length > 2 || hrs.length < 1 || mins.length !== 2) {
      throw new Error('Invalid duration format. Expected hh:mm.');
    }

    const hours = Number(hrs);
    const minutes = Number(mins);
    return minutes ? hours * 60 + minutes : hours * 60;
  };

  /**
   * converts the total minutes to hours and minutes
   * @param totalMins total minutes to convert to hours and minutes
   * @returns array with hours and minutes
   */
  public static convertMinsToDuration = (totalMins: number) => {
    const hours = Math.floor(totalMins > 59 ? totalMins / 60 : 0);
    const minutes = Math.floor(hours > 0 ? totalMins % (hours * 60) : totalMins);

    return [hours, minutes];
  };

  /**
   * formats the number received to a string with a leading 0 if the number is less than 10
   * @param num number to format
   * @returns formatted string
   */
  public static formatDurationSegment = (num = 0) => (num < 10 ? `0${num}` : num).toString();
}
